'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import RaceMap from './RaceMap';
import ElevationChart from './ElevationChart';

export default class RaceGraphics extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    id: PropTypes.number.isRequired,
    button: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      pos: [this.props.data[0].lat, this.props.data[0].lng],
      toggleButton: true,
      isFullscreen: false,
      toggleClose: false,
    };
  }

  moveCursor = (index) => {
    const lat = this.props.data[index].lat;
    const lng = this.props.data[index].lng;
    this.setState({ pos: [lat, lng] });
  };

  handleClick = (e) => {
    this.setState({toggleButton: false, toggleClose: true });
    const elem = document.querySelector('#' + 'container_' + this.props.id);
    elem.classList.add('fullscreen');
    this.makeFullscreen(elem);
    this.iframeLoading(elem, e);
  }

  makeFullscreen = (elem) => {
    if (
      document.fullscreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled
    ) {
      this.setState({isFullscreen: true, toggleClose: true});
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      document.querySelector('.error').innerHTML = 'Your browser is not supported';
    }
  }

  browserPrefix = () => ['webkitfullscreenchange', 'mozfullscreenchange', 'fullscreenchange', 'MSFullscreenChange']

  iframeLoading = (elem, e) => {
    this.browserPrefix().map((i) => {
      elem.addEventListener(i, () => {
        if (document.fullscreenElement === null) {
          this.setState({toggleButton: true, isFullscreen: false});
          elem.classList.remove('fullscreen');
          window.scrollTo(0, e.pageY - 500);
        }
      });
    });
  }

  exitFullscreen = () => {
    document.exitFullscreen();
    this.setState({toggleButton: true, toggleClose: false});
  }

  styles = {
    close: {
      position: 'absolute', 
      top: 10, 
      right: 60, 
      zIndex: 1000,
      padding: 11,
      backgroundColor: '#ffffff',
      border: '2px solid rgba(0,0,0,0.2)',
      borderRadius: 4,
      backgroundClip: 'padding-box',
    },
  }

  render() {
    return (
      <div className="mapChartContainer" id={`container_${this.props.id}`}>
        <RaceMap data={this.props.data} id={this.props.id} markerPos={this.state.pos} fullscreen={this.state.isFullscreen} />
        <ElevationChart data={this.props.data} raceId={this.props.id} moveCursor={this.moveCursor} />
        {this.state.toggleButton && (<div className="link_holder align-center my-3">
          <button onClick={this.handleClick} className="btn btn-primary btn-swiss-running go_fullscreen">{this.props.button}</button>
        </div>)}
        {this.state.toggleClose && (<button style={this.styles.close} onClick={this.exitFullscreen} className="btn btn-light btn-primary" href="#"><img style={{width: 20, height: 20}} src={'/assets/close.svg'}/></button>)}
      </div>
    );
  }
}
